import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@decisiv/ui-components';
import Download from '@decisiv/iconix/lib/components/Download';
import { t, Trans } from '@lingui/macro';

import { FloatingBar, SelectionCount } from './style';

export default function IntegrationSelectionBar({
  count,
  max,
  onExport,
  onCancel,
}) {
  return (
    <FloatingBar name="integration-selection-bar">
      <SelectionCount>
        <Trans>
          {count} / {max} integrations selected
        </Trans>
      </SelectionCount>
      <Button
        text={t`Export Selected`}
        icon={Download}
        iconPosition="left"
        kind="primary"
        size="small"
        disabled={count === 0}
        onClick={onExport}
      />
      <Button
        text={t`Cancel`}
        kind="secondary"
        variant="inverted"
        size="small"
        onClick={onCancel}
      />
    </FloatingBar>
  );
}

IntegrationSelectionBar.propTypes = {
  count: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  onExport: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};
